import { render, staticRenderFns } from "./PlanejamentoAcaoVerbaVariavelFormProdutos.vue?vue&type=template&id=238ace15"
import script from "./PlanejamentoAcaoVerbaVariavelFormProdutos.vue?vue&type=script&lang=js"
export * from "./PlanejamentoAcaoVerbaVariavelFormProdutos.vue?vue&type=script&lang=js"
import style0 from "./PlanejamentoAcaoVerbaVariavelFormProdutos.vue?vue&type=style&index=0&id=238ace15&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports